"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SPRING_CONFIG = { tension: 720, mass: 0.5 };
